import { housesDict } from "../HouseInfo";
import Property from "../../components/Property/Property";

function CondoTwoFour() {
  return (
    <div>
      <Property
        {...{
          housesDict: housesDict["C204"],
          propertyId: "694eb191a311eb33ac04b7ab",
        }}
      />
    </div>
  );
}

export default CondoTwoFour;
